import React from "react";
import { Draggable } from "react-beautiful-dnd";
interface Props {
  data: any;
  headers: any[];
  index: number;
}

export default ({ data, index, headers }: Props) => {
  const isDraggable = !!data.columns[0]?.isDragHandle;
  const indexAdd = isDraggable ? 1 : 0;

  const [firstColumn] = isDraggable ? data.columns.slice(0, 1) : [];
  const restOfColumns = isDraggable ? data.columns.slice(1) : data.columns;

  return data.draggable ? (
    <Draggable draggableId={data.id} index={index}>
      {(provided) => (
        <div
          className="tt-qq intensities-table"
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={{
            display: "flex",
            flex: "1",
            alignItems: "center",
            background: "#fff",
            border: "1px solid #eee",
            borderRadius: "6px",
            padding: "8px 12px",
            maxHeight: "80px",
            minHeight: "80px",
            ...data.style,
            ...provided.draggableProps.style,
          }}
        >
          {firstColumn && (
            <div
              className="test"
              style={{
                ...firstColumn.style,
              }}
            >
              {firstColumn.print
                ? firstColumn.print(firstColumn.content)
                : firstColumn.content}
            </div>
          )}

          {restOfColumns.map((column: any, idx: any) => (
            <div
              key={idx + indexAdd}
              style={{
                ...column.style,
              }}
            >
              {column.print ? column.print(column.content) : column.content}
            </div>
          ))}
        </div>
      )}
    </Draggable>
  ) : (
    <div className="tt-qq intensities-table">
      {data.columns.map((column: any, idx: any) => (
        <div key={idx}>
          {column.print ? column.print(column.content) : column.content}
        </div>
      ))}
    </div>
  );
};
